import axios from "axios";

export default {

  /**
   * WindyAPIを使って気象海象予報を取得.
   */
  async fetchForecast({ commit, dispatch }, lngLat) {
    const lat = lngLat.lat;
    const lng = lngLat.lng;

    const windiApiUrl = String(process.env.VUE_APP_WINDY_API_URL);
    const windyApiKey = String(process.env.VUE_APP_WINDY_API_KEY);

    // gfsモデルの気象データを取得 （風情報など）
    let gfsForecastData = await axios
      .post(windiApiUrl,{
        lat: lat,
        lon: lng,
        model: 'gfs',
        parameters: ["temp","dewpoint","precip","convPrecip","snowPrecip","wind","windGust","cape","ptype","lclouds","mclouds","hclouds","rh","gh","pressure"],
        levels: ['surface'],
        key: windyApiKey,
      })
      .then(response => {
        return response.data;
      });

    // wavewatchモデルの気象データを取得 （波情報など）
    let wavewatchForecastData = await axios
      .post(windiApiUrl,{
        lat: lat,
        lon: lng,
        model: 'wavewatch',
        parameters: ['waves', 'windWaves', 'swell1', 'swell2'],
        levels: ['surface'],
        key: windyApiKey,
      })
      .then(response => {
        return response.data;
      });

    // gfsとwavewatchの気象データを合成
    Object.assign(gfsForecastData.units,wavewatchForecastData.units);
    const forecastData = ( wavewatchForecastData.ts.length < gfsForecastData.ts.length )
            ? Object.assign(wavewatchForecastData, gfsForecastData)
            : Object.assign(gfsForecastData, wavewatchForecastData);

    // 視認理解しやすいように加工
    const adjustedForecastData = await dispatch('adjustForecastData', forecastData);

    commit("SET_FORECAST_DATA", adjustedForecastData );
  },

  /**
   * WindyAPIのデータを視認理解しやすいように加工.
   */
  adjustForecastData( _nouse, forecastData ) {
    let adjustedForecastData = {
      ts: forecastData.ts,
      units: forecastData.units,
    };

    for(let key in forecastData) {
      if (key !== 'ts' && key !== 'units' ){
        if (Array.isArray(forecastData[key])) {
          let workArray = forecastData[key];
          if ( forecastData.units[key] === 'K' ) {
            // ケルビン → 摂氏変換
            adjustedForecastData.units[key] = '°C';
            workArray = workArray.map(workData => { return workData - 273.15 });

          } else if ( forecastData.units[key] === 'Pa' ) {
            // パスカル → ヘクトパスカル
            adjustedForecastData.units[key] = 'hPa';
            workArray = workArray.map (workData => { return workData / 100 } );

          } else if ( forecastData.units[key] === 'm*s-1' ) {
            // m/s の整形
            adjustedForecastData.units[key] = 'm/s';
          }

          adjustedForecastData[key] = workArray.concat(Array(forecastData.ts.length - workArray.length).fill(null));
        } else {
          adjustedForecastData[key] = forecastData[key];
        }

        // 風量ベクトル情報から、風速と風方向を生成する。
        if ( key === 'wind_u-surface' && forecastData['wind_v-surface'] ) {

          adjustedForecastData['wind_direction-surface'] = [];
          adjustedForecastData['wind_speed-surface'] = [];

          forecastData['wind_u-surface'].forEach((workData, index) => {
            let windU = workData;
            let windV = forecastData['wind_v-surface'][index];

            // 三平方の定理でベクトル量を合成し、風速を算出する。
            let windSpeed = ( windU && windV ) ? Math.sqrt(Math.pow(windU, 2) + Math.pow(windV, 2)) : null;
            adjustedForecastData['wind_speed-surface'].push(windSpeed);
            adjustedForecastData.units['wind_speed-surface'] = 'm/s';

            // ArcTangentでベクトル比率から風方向を算出する。
            let windDirection = (windV === 0 ? 1 : Math.atan( windU / windV )) * ( 180 / Math.PI ) - ( windV >= 0 ? 0 : 180 );
            adjustedForecastData['wind_direction-surface'].push(windDirection);
            adjustedForecastData.units['wind_direction-surface'] = 'deg';

          });
        }
      }
    }

    return adjustedForecastData;
  },

  clearForecast({ commit }) {
    commit("CLEAR_FORECAST_DATA");
  },
};
